<template lang="pug">
  div.error
    div.error-header
      div.logo
        img(src="../../assets/logo_big.svg")
      h1 {{code}}
    div.error-body
      b-btn(variant="link", :href="referrer") {{referrer}}
</template>

<script>
export default {
  name: 'file-not-found',
  props: {
    code: {
      type: [Number, String],
      required: true
    },
    referrer: {
      type: String,
      default: document.referrer
    }
  }
}
</script>

<style lang="scss" scoped src="./error.scss"></style>
